// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import Close from "@werner/XDL/Icons/Close";
import { xBaseTheme } from "@werner/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        bodyTypographyProps: {
            mergeCss: true,
            size: 15,
            weight: 400,
            css: css`
                letter-spacing: 0;
                line-height: 17px;
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 10,
            color: "common.ui3",
        },
        closeButtonProps: {
            mergeCss: true,
            css: css`
                width: 10px;
                height: 10px;
                padding: 0;
                margin: 16px;
                top: 0;
                position: absolute;
                right: 0;
            `,
        },
        cssOverrides: {
            toast: css`
                border-width: 0 0 0 5px;
            `,
        },
    },
    toasterProps: {
        position: "bottom-right",
        mobilePosition: "bottom",
    },
} as xBaseTheme["toast"];
